import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { ThemeProvider, initializeTheme } from './components/Theme'
import './styles/app.css'
import './styles/workspace.css'
import './styles/interface.css'
import './styles/themes.css'

initializeTheme()

const root = document.getElementById('root')
if (!root) throw new Error('#root missing from index.html')

createRoot(root).render(
  <StrictMode>
    <ThemeProvider><App /></ThemeProvider>
  </StrictMode>,
)
